
import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/fireLedger',
    meta: { title: '消防台账' },
    component: Layout,
    redirect: '/fireLedger/list',
    children: [
      {
        path: 'list',
        meta: { title: '消防台账', activeMenu: '/fireLedger' },
        component: () => import('@/views/fireLedger/FireLedger.vue')
      },
      {
        path: 'detail',
        meta: { title: '消防台账详情', activeMenu: '/fireLedger' },
        component: () => import('@/views/fireLedger/FireLedgerDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑消防台账', activeMenu: '/fireLedger' },
        component: () => import('@/views/fireLedger/FireLedgerAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增消防台账', activeMenu: '/fireLedger' },
        component: () => import('@/views/fireLedger/FireLedgerAdd.vue')
      }

    ]
  }

]
